import { FormInput, Grid, FormGetter, FormSetter } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Typography, Divider, Paper } from '@mui/material';
import React from 'react';

import { FormButton } from 'components/FormButton';

import { FilesField } from '../FilesField';
import { StepWrapper } from '../StepWrapper';

type PaymentInfo = {
  voornaam: string;
  naam: string;
  bedrag: string;
};

export default function Step() {
  return (
    <StepWrapper
      name="Betaalde onderhoudsuitkeringen"
      description="Gelieve volgende informatie in te vullen indien u het afgelopen jaar onderhoudsuitkeringen heeft betaald"
      maxWidth={1000}
    >
      <FormGetter
        names={['paid_payments']}
        render={({ paid_payments = [] }) => (
          <Grid container spacing={0}>
            <Grid xs={12} sx={{ mb: 2 }}>
              <FormSetter
                render={(setValue) => (
                  <FormButton
                    variant="outlined"
                    onClick={() => {
                      setValue('paid_payments', [
                        ...paid_payments,
                        {
                          voornaam: '',
                          naam: '',
                          bedrag: '',
                        },
                      ]);
                    }}
                    startIcon={<AddIcon />}
                  >
                    Uitkering toevoegen
                  </FormButton>
                )}
              />
            </Grid>

            {paid_payments.map((payment: PaymentInfo, index: number) => (
              <Grid xs={12} key={index}>
                <Paper
                  elevation={1}
                  sx={{
                    p: 3,
                    mb: 2,
                    width: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.02)',
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                  >
                    <Typography variant="h6" color="primary">
                      Uitkering {index + 1}
                    </Typography>
                    <FormSetter
                      render={(setValue) => (
                        <FormButton
                          variant="outlined"
                          color="error"
                          size="small"
                          onClick={() => {
                            const newPayments = [...paid_payments];
                            newPayments.splice(index, 1);
                            setValue('paid_payments', newPayments);
                          }}
                          startIcon={<DeleteIcon />}
                        >
                          Verwijderen
                        </FormButton>
                      )}
                    />
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Grid container spacing={2}>
                    <Grid xs={12}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontSize: '0.875rem',
                          color: '#65748B',
                          fontWeight: 400,
                        }}
                      >
                        Aan wie werd de onderhoudsuitkering betaald
                      </Typography>
                    </Grid>

                    <FormInput
                      name={`paid_payments.${index}.voornaam`}
                      label="Voornaam"
                      xs={12}
                      sm={6}
                      required
                    />
                    <FormInput
                      name={`paid_payments.${index}.naam`}
                      label="Naam"
                      xs={12}
                      sm={6}
                      required
                    />

                    <Grid xs={12}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontSize: '0.875rem',
                          color: '#65748B',
                          fontWeight: 400,
                        }}
                      >
                        Betaald bedrag uitkering
                      </Typography>
                    </Grid>
                    <FormInput
                      name={`paid_payments.${index}.bedrag`}
                      label="Bedrag"
                      xs={12}
                      sm={6}
                      required
                    />

                    <FilesField
                      name={`paid_payments.${index}.documenten`}
                      title="Upload hier alle fiches/attesten/bankuittreksels ivm betaalde onderhoudsuitkeringen"
                      xs={12}
                      md={12}
                    />
                  </Grid>
                </Paper>
              </Grid>
            ))}
          </Grid>
        )}
      />
    </StepWrapper>
  );
}
